export class ContactMessage {
    constructor(
        public to: Array<string>,
        public title: string,
        public body: string
    ) {
    }
}
